import {useDispatch, useSelector} from "react-redux";
import {Button} from "primereact/button";
import React from "react";
import {Dialog} from "primereact/dialog";
import {clearError} from "../../redux/slices/statusSlice";

const ErrorModal = () => {
    const error = useSelector(state => state.status.error);
    const errorHeader = useSelector(state => state.status.errorHeader);
    const dispatch = useDispatch();

    if(!error) return (<></>);

    const onHide = () => {
        dispatch(clearError());
        window.location.reload();
    }

    const renderFooter = () => {
        return (
            <div>
                <Button type="button" label="Close" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            </div>
        );
    }

    return (
        <Dialog modal={true} header={errorHeader || `Unexpected Error Occurred`} visible={true} style={{ width: '50vw', height: '80vh' }} footer={renderFooter()} onHide={() => onHide()}>
            <div className="formgrid grid">
                <div className="col-12">
                    <span className="error">{JSON.stringify(error)}</span>
                </div>
            </div>
            <div className="formgrid grid">
                <div className="col-12">
                    <span>If problem persists, please contact site administrator</span>
                </div>
            </div>
        </Dialog>
    );
}

export default ErrorModal;
